<template>
    <el-dialog custom-class="x-dialog"
        :close-on-click-modal="false"
        :model-value="visible"
        :fullscreen="config.fullscreen"
        :title="config?.title || '提示：'" :width="config?.width || 1280"
        :style="`max-width:${config?.maxWidth ? config.maxWidth + 'px' : 'initial'}`"
        :key="(Date.now())"
        :show-close="config.showClose !== false"
        :close-on-press-escape="config.showClose !== false"
        @update:module-value="(value)=> {$emit('update:visible', value); if (!value) $emit('close')}"
        @close="close()" 
    >
        <template #header="{ close, titleId, titleClass }">
            <slot name="header" :close="close" :title="config?.title || '提示：'" :titleId="titleId" :titleClass="titleClass"></slot>
        </template>
        <template #default>
            <slot name="default" :check="check"></slot>
        </template>
        <template #footer>
            <div class="x-bar clearfix" v-if="hasButtons(config)">
                <x-button-group
                    :config="getButtonsConfig(config)"
                    :data="data"
                    @click="buttonClickHandler"
                ></x-button-group>
            </div>
        </template>
    </el-dialog>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue';
import XButtonGroup from '../components/base/XButtonGroup.vue';

const inst = getCurrentInstance()

const props = defineProps({
    visible: { default: true },
    component: { default: null },
    config: { default: null },
    data: { default: null },
})
defineEmits({
    'confirm': null,
    'close': null,
    'update:visible': null,
})

const check = ref({
    cb: null
})

const modelData = ref({});

const close = ()=> {
    inst.emit('update:visible', false);
    inst.emit('close');
}
const confirm = (action)=> {
    const data = modelData.value || {};
    inst.emit('confirm', data, action);
    if (data['promise']) {
        data['promise'].then((valid)=> {if (valid) close()});
    } else close();
}

const DEF_DIALOG_BUTTONS = [{code:'CANCEL', name:'取消'}, {code:'CONFIRM', name:'确定'}];

const hasButtons = (config)=> {
    return config.buttons && config.buttons.length || (config.withDefaultButtons !== false);
}
const getButtonsConfig = (config)=> {
    let buttons = null;
    if (config.withDefaultButtons === null && (!config.buttons || !config.buttons.length)) buttons = null;
    else {
        const actualButtons = config.withDefaultButtons !== false ? DEF_DIALOG_BUTTONS.slice() : [];
        if (config.buttons && config.buttons.length) buttons = actualButtons.concat(config.buttons);
        else buttons = actualButtons.length ? actualButtons : null;
    }
    // let viewButtons = null;
    // if (buttons) {
    //     for (const button of buttons) {
    //         const state = button.state || (ViewState.VIEW | ViewState.EDIT | ViewState.CREATE);
    //         if ((state & viewState) > 0) {
    //             if (!viewButtons) viewButtons = [];
    //             viewButtons.push(button);
    //         }
    //     }
    // }
    return {align:'center', grouped:false, buttons:buttons};
}

const buttonClickHandler = (button)=> {
    switch (button.code) {
        case 'CANCEL': close(); break;
        default:
        case 'CONFIRM': confirm(button.code); break;
    }
}
</script>
<style>
.x-dialog.el-dialog > header > button.el-dialog__headerbtn:focus {
    outline: 0;
}
.x-dialog.el-dialog > header {
    border-bottom: 1px solid #ddd;
    margin: 0;
}
.x-dialog.el-dialog > div.el-dialog__body {
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>